import Ajax from '../common/ajax'
import ApiBase from './api-base'

export default {
  ...ApiBase,
  model: 'examOnline',
  getExamInfo (id) {
    return Ajax.get(`/api/gradeMaster/v1/${this.model}/examineeInfo/${id}`)
  },
  editExam (data = {}) {
    return Ajax.put(`/api/gradeMaster/v1/${this.model}/updateExam`, data)
  },
  getExamSubjectList (id) {
    return Ajax.get(`/api/gradeMaster/v1/${this.model}/listExamSubject/${id}`)
  },
  getEnrollDetail (id) {
    return Ajax.get(`/api/gradeMaster/v1/${this.model}/enrollDetail/${id}`)
  },
  getSubjectGroupList (id) {
    return Ajax.get(`/api/gradeMaster/v1/${this.model}/listSubject/${id}`)
  },
  addExamSubject (data = {}) {
    return Ajax.post(`/api/gradeMaster/v1/${this.model}/addExamSubject`, data)
  },
  editExamSubject (data = {}) {
    return Ajax.put(`/api/gradeMaster/v1/${this.model}/updateExamSubject`, data)
  },
  reSet (data = {}) {
    return Ajax.post(`/api/gradeMaster/v1/${this.model}/reset`, data)
  },
  refundExam (id) {
    return Ajax.get(`/api/gradeMaster/v1/${this.model}/refundOrder/${id}`)
  },
  exportExcel (param) {
    return Ajax.post(`/api/gradeMaster/v1/${this.model}/exportEnrollExam`, param)
  },
  importOfficialPhoto (param) {
    return Ajax.post(`/api/gradeMaster/v1/${this.model}/importOfficialPhoto`, param)
  },
  autoReplacePhoto (param) {
    return Ajax.post(`/api/gradeMaster/v1/${this.model}/autoReplacePhoto`, param)
  },
  changeExamBatch (param) {
    return Ajax.post(`/api/gradeMaster/v1/${this.model}/changeExamBatch`, param)
  },
  getTemporary (id) {
    return Ajax.get(`/api/gradeMaster/v1/${this.model}/temporaryPwd/${id}`)
  },
  resetExaminnePwd (id) {
    return Ajax.get(`/api/gradeMaster/v1/${this.model}/resetPwd/${id}`)
  },
  sendSms (param) {
    return Ajax.post(`/api/gradeMaster/v1/${this.model}/sendSms`, param)
  },
  changeGrade (param) {
    return Ajax.post(`/api/gradeMaster/v1/${this.model}/changeSpecialtyGrade`, param)
  },
  queryExaminee (param) {
    return Ajax.post(`/api/gradeMaster/v1/${this.model}/queryExaminee`, param)
  },
  enableExaminee (id) {
    return Ajax.get(`/api/gradeMaster/v1/${this.model}/enable/${id}`)
  },
  getRefundExam (param) {
    return Ajax.post(`/api/gradeMaster/v1/${this.model}/pageRefundExam`, param)
  },
  AuthExaminee (data = {}) {
    return Ajax.post(`/api/gradeMaster/v1/${this.model}/batchAuth`, data)
  }
}
